import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../lib/firebase";

export const getUserProfile = async (uid) => {
  const docRef = doc(db, "users", uid);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  }
  return null;
};

export const updateUserProfile = async (uid, data) => {
  console.log("updateUserProfile called for UID:", uid, "with data:", data);
  try {
    const docRef = doc(db, "users", uid);
    await setDoc(docRef, data, { merge: true });
    console.log("Firestore setDoc successful");
  } catch (error) {
    console.error("Firestore setDoc failed:", error);
    throw error;
  }
};

export const saveUserAddress = async (uid, address) => {
  const userProfile = await getUserProfile(uid);
  const addresses = userProfile?.addresses || [];
  
  // Check if address already exists to avoid duplicates
  const exists = addresses.find(a => 
    a.addressLine1 === address.addressLine1 && 
    a.city === address.city && 
    a.zipCode === address.zipCode
  );

  if (!exists) {
    const updatedAddresses = [...addresses, { ...address, id: Date.now().toString() }];
    await updateUserProfile(uid, { addresses: updatedAddresses });
    return updatedAddresses;
  }
  return addresses;
};
